import * as yup from 'yup'
import { DEFAULT_COUNTRY_CODE } from 'components/address/countries'

const requiredText = message => yup.string().trim().required(message)
const urlPattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/

const schema = yup.object({
  companyName: requiredText('Name is required'),
  street: requiredText('Street is required'),
  addressLine2: yup.string().optional(),
  city: requiredText('City is required'),
  zipCode: requiredText('Postal code is required'),
  countryCode: requiredText('Country is required'),
  countryName: yup.string().optional(),
  latitude: yup.number().nullable().optional(),
  longitude: yup.number().nullable().optional(),
  state: yup.string().trim().when('countryCode', {
    is: DEFAULT_COUNTRY_CODE,
    then: schema => schema.required('State is required'),
    otherwise: schema => schema.optional(),
  }),
  businessPhone: yup.string().test('phone-format', 'Phone must be blank or in format (212) 555-1234',
    value => !value?.trim() || /^\(\d{3}\) \d{3}-\d{4}$/.test(value)).optional(),
  siteUrl: requiredText('Site url is required')
    .matches(urlPattern, { message: 'Url is not valid', excludeEmptyString: true })
    .max(240, 'Too many characters'),
  logoUrl: requiredText('Logo is required'),
  categories: yup.array().typeError('Pick a category')
    .required('Pick a category').min(1, 'Pick a category'),
  fulfillment: requiredText('Fulfillment is required')
    .oneOf(['RETAIL', 'SERVICE', 'RETAIL_AND_SERVICE'], 'Select a fulfillment type'),
  jobTitle: yup.string().trim().max(255, 'Too many characters')
    .when('$isContactOwner', { is: true, then: schema => schema.required('Enter a job title of 1 to 255 characters for this business.') }),
  accountName: yup.string().trim().when(['$needsAccount', '$sameAccountName'], {
    is: (needsAccount, sameAccountName) => needsAccount && !sameAccountName,
    then: schema => schema.required('Enter an account name of 1 to 255 characters.').max(255, 'Enter an account name of 1 to 255 characters.'),
  }),
})

export default schema
